/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { type PropsWithChildren, useMemo, useState } from 'react';
import { DesktopLayoutContext } from './desktopLayout';

export function DesktopLayoutProvider({ children }: Readonly<PropsWithChildren>) {
  const [reservedRight, reserveRight] = useState(0);
  const value = useMemo(() => ({ reservedRight, reserveRight }), [reservedRight]);
  return <DesktopLayoutContext value={value}>{children}</DesktopLayoutContext>;
}
